export default __webpack_public_path__ + "static/media/image-6.80c30c7e.png";